import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { walletAPI } from '../api/client';
import { formatDistanceToNow } from 'date-fns';

export const TransactionsPage = () => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await walletAPI.getTransactions();
      setTransactions(response.data.data);
    } catch (err) {
      console.error('Error fetching transactions:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 text-gray-400">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800">
      <nav className="bg-slate-800 border-b border-slate-700 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded flex items-center justify-center text-lg font-bold">₹</div>
            <h1 className="text-2xl font-bold text-white">PaySolutions</h1>
          </div>
          <button
            onClick={() => navigate('/dashboard')}
            className="text-gray-400 hover:text-yellow-400 transition"
          >
            Back
          </button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto py-12 px-4">
        <h2 className="text-2xl font-bold text-white mb-6">Transaction History</h2>

        {transactions.length === 0 ? (
          <div className="bg-slate-800 rounded-xl shadow-lg p-8 text-center border border-slate-700">
            <p className="text-gray-400">No transactions yet</p>
          </div>
        ) : (
          <div className="bg-slate-800 rounded-xl shadow-lg overflow-hidden border border-slate-700">
            <table className="w-full">
              <thead className="bg-slate-700/50">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-300">Type</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-300">Amount</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-300">Commission</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-300">Net</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-300">Status</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-300">Date</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((tx) => (
                  <tr key={tx.id} className="border-t border-slate-700 hover:bg-slate-700/50 transition">
                    <td className="px-6 py-4 text-sm">
                      <span className="inline-block bg-blue-500/20 text-blue-300 px-2 py-1 rounded border border-blue-500/30">
                        {tx.type === 'wallet_load' ? '💰 Load In' : '🏦 Withdrawal'}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm font-semibold text-white">₹{tx.gross_amount}</td>
                    <td className="px-6 py-4 text-sm text-orange-400">-₹{tx.commission_amount}</td>
                    <td className="px-6 py-4 text-sm font-semibold text-emerald-400">₹{tx.net_amount}</td>
                    <td className="px-6 py-4 text-sm">
                      <span className={`px-2 py-1 rounded ${
                        tx.status === 'success' ? 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30' :
                        tx.status === 'pending' ? 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30' :
                        'bg-red-500/20 text-red-300 border border-red-500/30'
                      }`}>
                        {tx.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-400">
                      {formatDistanceToNow(new Date(tx.created_at), { addSuffix: true })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
